'use strict';

export class Header {
  constructor() {
    this.name = 'header';
    console.log('%s module', this.name.toLowerCase());
    $("#block-sitebranding .ct-logo .ct-logo__image").removeClass("hide-xxs");
    $('.ct-mobile-navigation__top-menu li a').click(function(){
      $('#block-bcast-mobile-navigation').click();
  });
  
  }
}
